import React from 'react';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import Heading from '@marvelapp/marvel-ui/heading';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';

import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import Image from 'marketing-website/components/modules/Image';
import Page from 'marketing-website/components/modules/Page';
import TickedCopy from 'marketing-website/components/modules/TickedCopy';
import WebinarForm from 'marketing-website/components/modules/WebinarForm';

import assets from 'marketing-website/configs/pages/workshop/workshop.js';

import { formEbook } from 'marketing-website/configs/hubspot';
import metaData from 'marketing-website/data/metadata.js';

import ebookData from 'marketing-website/configs/pages/ebook/ebook.js';
import styles from './style/general.module.css';
import LandingPagesWrap from '../../components/modules/LandingPagesWrap';

const {
  resources: { workshops },
} = metaData;
const meta = {
  title: workshops.title,
  meta: [
    {
      name: 'description',
      content: workshops.description,
    },
  ],
  header: false,
  footer: true,
};

const messaging = {
  header: (
    <Spacing type="margin" size="xs" position="bottom">
      <Heading tag="h1" size="xxl" weight="semibold">
        Download the kit, for free!{' '}
      </Heading>
    </Spacing>
  ),
  copy: (
    <Spacing type="margin" size="l" position="bottom">
      <Paragraph size="m" color="silver">
        Simply fill out the form below to get your hands on the Workbook,
        Facilitator Guide, Workshop Slides and Presentation Template Slides.
      </Paragraph>
    </Spacing>
  ),
};

export default function Workshops() {
  return (
    <Page {...meta}>
      <LandingPagesWrap color={'black'}>
        <div
          id="enterprise-form"
          style={{ backgroundColor: '#FFDFF2', overflow: 'hidden' }}
        >
          <PageWrap>
            <Spacing size="xl" position="top" type="padding">
              <Spacing size="xl" position="topBottom" type="padding">
                <Grid columns={12} alignContent="center">
                  <GridItem columnSpan={12} columnSpanM={6}>
                    <Spacing type="margin" size="s" position="bottom">
                      <HeadingBlock
                        justifyM="start"
                        headingSize="xxxxl"
                        paragraphSize="xxl"
                        paragraphMaxWidth={600}
                        headingMaxWidth={450}
                        title="The Design Thinking Workshop Kit"
                        copy={
                          <span>
                            Empower everyone in your business to solve problems,
                            together.
                          </span>
                        }
                      />
                    </Spacing>

                    <div className={styles.imageEbook}>
                      <div className={styles.imageSpacing}>
                        <Image {...assets.hero} useImageTag />
                      </div>
                    </div>

                    <Spacing type="padding" position="topBottom" size="m">
                      <HeadingBlock
                        justifyM="start"
                        headingSize="xxl"
                        paragraphMaxWidth={600}
                        headingMaxWidth={450}
                        title="Run your first Design Thinking session"
                        copy={
                          <span>
                            This Workshop Kit will give you and your team a
                            simple, inclusive and reusable approach for running
                            sessions using the basic principles of Design
                            Thinking. Learn how to apply the stages empathise,
                            define, ideate, prototype and test to any problem,
                            in an interactive and fun session.
                          </span>
                        }
                      />
                    </Spacing>
                  </GridItem>

                  <GridItem columnSpan={12} columnSpanM={6} fullWidth>
                    <div className={styles.formPosition}>
                      <div className={styles.border}>
                        <div className={styles.formPadding}>
                          <WebinarForm
                            headerTitle={messaging.header}
                            headerText={messaging.copy}
                            btnColor="blue"
                            ctaCopy="Get Workshop Kit"
                            infoMessage="This one's on us!"
                            hubspotId={formEbook}
                            url={
                              '/resources/download-design-thinking-workshop-kit'
                            }
                            disallowedFields={['phoneNumber']}
                          />
                        </div>
                      </div>
                    </div>
                  </GridItem>
                </Grid>
                <Grid columns={12}>
                  <GridItem columnSpan={12} columnSpanM={6}>
                    <MaxWidth value={600}>
                      <div className="paddingTop-l">
                        <Spacing type="margin" position="topBottom" size="m">
                          <Heading tag="h2" size="xxl" weight="semibold">
                            Made to help you:
                          </Heading>
                        </Spacing>
                      </div>
                      {ebookData.map(item => (
                        <Spacing type="padding" position="bottom" size="s">
                          <TickedCopy
                            isCentered={false}
                            key={item.id}
                            size="l"
                            shouldShowBlackTick
                          >
                            {item}
                          </TickedCopy>
                        </Spacing>
                      ))}
                    </MaxWidth>
                  </GridItem>
                  <GridItem columnSpan={12} columnSpanM={6}>
                    <div className={styles.imageEbookTwo}>
                      <Spacing type="margin" position="bottom" size="l">
                        <Image {...assets.second} useImageTag />
                      </Spacing>
                    </div>
                  </GridItem>
                </Grid>
              </Spacing>
            </Spacing>
          </PageWrap>
        </div>
      </LandingPagesWrap>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/workshops/index.js